import { CustomPageHeading } from "../../../components/CustomPageHeading/CustomPageHeading";
import { BtnImportConfigId } from "../../../components/common/BtnImportConfigId/BtnImportConfigId";
import { AdministrationAreaDialog } from "../../../configurator/renderer/components/AdministrationAreaDialog/AdministrationAreaDialog";
import { useEasyServiceGetApiEasyAdministrationArea } from "../../../openapi/api/queries/queries";

import { JSX, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { VMItemGroups, VMQuotes /* useLanguage */ } from "@4pace-cpq/core";
import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useParams, useSearch } from "@tanstack/react-router";

export function CartViewHeading({
  itemGroupId,
}: {
  item: VMQuotes;
  itemGroupId: VMItemGroups["id"];
}): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  //const { languages, setLanguageById } = useLanguage();

  const { data: administrationAreaData, isSuccess } =
    useEasyServiceGetApiEasyAdministrationArea();

  const [administrationArea, setAdministrationArea] = useState<string>();

  const { productCategory /* language */ } = useSearch({ strict: false });

  useEffect(() => {
    setAdministrationArea(administrationAreaData?.string ?? "");
  }, [administrationAreaData]);

  /*   useEffect(() => {
    if (language) {
      const languageData = languages.find(
        (lang) => lang.languageCode?.split("-")[0] === language,
      );
      if (languageData) {
        setLanguageById(languageData.id);
      }
    }
  }, [language, languages, setLanguageById]); */

  const { cartId: quoteId } = useParams({
    strict: false,
  });

  function routeToConfigurator(): void {
    navigate({
      to: `/configurator?cfgObjectId=&productId=&quoteId=${quoteId}&itemGroupId=${itemGroupId}&lineItemId=&administrationArea=${administrationArea}&productCategory=${productCategory}`,
    });
  }

  if (productCategory && administrationArea) {
    navigate({
      to: `/configurator?cfgObjectId=CFG_PROFESSIONAL&productId=&quoteId=${quoteId}&itemGroupId=${itemGroupId}&lineItemId=&administrationArea=${administrationArea}&productCategory=${productCategory}`,
    });
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
      }}
    >
      <CustomPageHeading
        text={t("WEG:header.cart.title")}
        //subtitle={item.name}
      />
      <Box
        display="flex"
        gap={2}
        sx={{ mt: "1rem", marginRight: "1rem", marginBottom: "rem" }}
      >
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={routeToConfigurator}
        >
          <Typography>{t("WEG:cartViewHeader.button.title")}</Typography>
        </Button>
        <BtnImportConfigId />
        {isSuccess && administrationAreaData.string === "" && (
          <AdministrationAreaDialog
            setAdministrationArea={setAdministrationArea}
          />
        )}
      </Box>
    </Box>
  );
}
